import { render } from "./TextField.vue?vue&type=template&id=c708fb7e"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/harixx_test/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TextField.vue"]])

export default __exports__